/*----------------------------------
- ROUTE: /agenda
----------------------------------*/

/**
 * @docs docs/features/agenda
 * @adr  ADR-0055
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { definePageRoute } from '@common/router/definitions';

import { buildAgendaRouteData, renderAgendaRoute } from './lib/route';

/*----------------------------------
- PAGE
----------------------------------*/

// No `static`: the view and the filters live in the query, and a static page is cached by
// path whatever the query (D28). Rendered on every request, behind a keyed read cache.
export default definePageRoute({
    path: '/agenda',
    options: { auth: false, layout: false },
    data: buildAgendaRouteData,
    render: renderAgendaRoute,
});
